import React, { useState } from "react";
import {
  withStyles,
  MenuItem,
  FormControl,
  Select,
  InputBase,
  Typography,
} from "@material-ui/core";

import dropdownicon from "../../assets/images/settings/dropdownicon.svg";
import { Icon } from "./Icon";
import { COLORS } from "../../theme/colors";

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: (props) => props.padding,
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:focus": {
      borderRadius: 4,
      borderColor: COLORS.purple,
      boxShadow: `0 0 0 0.05rem ${COLORS.purple}`,
    },
  },
}))(InputBase);

export function DropdownInput({
  label,
  labelRoot,
  labelField,
  valueField,
  setvalue,
  value,
  options,
  style,
  defaultValue,
  icon = dropdownicon,
  fullWidth = true,
  iconWidth,
  inputPadding = "10px 26px 10px 12px",
}) {
  const [open, setOpen] = useState(false);
  const handleChange = (event) => {
    setvalue(event.target.value);
  };

  return (
    <>
      <FormControl fullWidth={fullWidth} style={style}>
        {label && <Typography className={labelRoot}>{label}</Typography>}
        <Select
          labelId="demo-customized-select-label"
          id="demo-customized-select"
          value={value}
          onChange={handleChange}
          input={<BootstrapInput padding={inputPadding} />}
          defaultValue={defaultValue}
          IconComponent={() => (
            <Icon
              src={icon}
              style={{
                position: "absolute",
                right: "10px",
                width: iconWidth ? iconWidth : "initial",
              }}
              onClick={() => setOpen(!open)}
            />
          )}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          open={open}
        >
          {options?.map((item) => {
            const value = valueField ? item[valueField] : item;
            return (
              <MenuItem key={value} value={value}>
                {labelField ? item[labelField] : item}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </>
  );
}
